import { render, staticRenderFns } from "./debugger.vue?vue&type=template&id=56e845e1&"
import script from "./debugger.vue?vue&type=script&lang=js&"
export * from "./debugger.vue?vue&type=script&lang=js&"
import style0 from "./debugger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports